// extracted by mini-css-extract-plugin
export var clickable = "work-module--clickable--xDwGt";
export var gridcontainer = "work-module--gridcontainer--RsXvM";